import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CoverageZonesApiAdapter } from '../adapters/CoverageZonesApiAdapter';

export const usePaymentMethods = () => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CoverageZonesApiAdapter(httpClient);

    const { data, isLoading, error, isPending } = useQuery({
        queryKey: ['payment-methods'],
        queryFn: () => apiAdapter.getPaymentMethods(),
        staleTime: Infinity, // Los métodos de pago no cambian, cachear indefinidamente
        gcTime: 1000 * 60 * 60, // 1 hora en garbage collection
    });

    return {
        paymentMethods: data ?? [],
        isLoading: isLoading || isPending,
        error,
        total: data?.length ?? 0,
    };
};

